import { reloadAuthorized } from './Authorized' // use localStorage to store the authority info, which might be sent from server in actual project.

// 获取是否跳转认证
export function getSkipAudit() {
    return localStorage.getItem(PROJECT_CONFIG.auditKey) || false
}

// 跳过认证
export function setSkipAudit() {
    localStorage.setItem(PROJECT_CONFIG.auditKey, true) // auto reload

    reloadAuthorized()
}

// 清除跳过认证
export function clearSkipAudit() {
    if (localStorage) {
        localStorage.removeItem(PROJECT_CONFIG.auditKey)
    }
}
